// CBA (City Based Application) status presentation, shared by every reader.
//
// The statuses live on the stage taxonomy term, so the same handful of values
// surface in more than one place: the Permit tab's CBA Status column
// (components/project-detail/PermitTab.vue) and the read-only summary on
// Forms/PermitApplicationForm.vue. Keeping the tone rule here means a new
// status word only has to be recognised once.
//
// The chip itself is styled globally as `.pt-cba` in
// assets/styles/permit-table.css, so both callers use the classes below
// verbatim rather than each mapping a tone onto its own prefix.

/**
 * The modifier class for one CBA status, or "" for a status with no tone.
 *
 * Matched on a substring because the vocabulary spells the same outcome several
 * ways ("Approved", "Approved in Principle", "Adopted / Approved").
 */
export function cbaStatusClass(status) {
  const s = String(status == null ? "" : status).toLowerCase();
  if (s.includes("approved")) return "pt-cba--approved";
  if (s.includes("adopted")) return "pt-cba--adopted";
  return "";
}

/**
 * The eight CBA statuses in the order the backend sends them: the key each one
 * takes on a flat row, and the short code the chip prints.
 *
 * Mirrors _presale_application_stage_cba_fields() in the backend's
 * end_points.inc — both the `permit_data` rows of api/get_utc and the
 * `permits_project` / `permits_ptc` / `permits_utc` rows of
 * api/get_single_project carry exactly these keys.
 */
export const CBA_CODES = [
  { key: "rz", code: "REZ" },
  { key: "dp", code: "DP" },
  { key: "dvp", code: "DVP" },
  { key: "sub", code: "SUB" },
  { key: "srv", code: "SERV" },
  { key: "demo", code: "DEMO" },
  { key: "ocp", code: "OCP" },
  { key: "bp", code: "BP" },
];

/**
 * The {code, status} chips for one flat row, blanks dropped.
 *
 * The backend emits all eight keys whether or not the stage term sets them, so
 * the filter is what keeps a row from rendering seven empty chips.
 */
export function cbaItemsFromFlat(row) {
  if (!row) return [];
  return CBA_CODES
    .map(({ key, code }) => ({ code, status: row[key] || "" }))
    .filter((item) => item.status);
}
